import React from 'react'

export default function Privacy() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 text-white">
      <h1 className="text-4xl font-bold">Privacy Policy</h1>

      <p className="mt-4 text-white/60 text-sm">
        Last Updated: May 10, 2026
      </p>

      <p className="mt-6 text-white/70 leading-7">
        Welcome to Delta Reloaded. Your privacy matters to us, and we want to
        be transparent about what information we collect, how we use it, and
        how we protect it.
      </p>

      <p className="mt-4 text-white/70 leading-7">
        By using Delta Reloaded, our website, game servers, Discord, or related
        services, you agree to this Privacy Policy.
      </p>

      <div className="mt-10 space-y-10">

        <section>
          <h2 className="text-2xl font-semibold">1. Information We Collect</h2>

          <div className="mt-4 space-y-4 text-white/70 leading-7">
            <p>
              Depending on how you use Delta Reloaded, we may collect certain
              information to help operate and improve our services.
            </p>

            <div>
              <h3 className="text-lg font-medium text-white">
                Information You Provide
              </h3>

              <ul className="mt-3 list-disc pl-6 space-y-2">
                <li>Username or display name</li>
                <li>Email address</li>
                <li>Account information</li>
                <li>Support messages or reports</li>
                <li>Community posts or uploaded content</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium text-white">
                Automatically Collected Information
              </h3>

              <ul className="mt-3 list-disc pl-6 space-y-2">
                <li>IP address</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Browser information</li>
                <li>Gameplay statistics</li>
                <li>Crash reports</li>
                <li>Login activity</li>
                <li>Security and anti-cheat information</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">2. How We Use Your Information</h2>

          <div className="mt-4 text-white/70 leading-7">
            <p>We use collected information to:</p>

            <ul className="mt-4 list-disc pl-6 space-y-2">
              <li>Operate and maintain Delta Reloaded</li>
              <li>Improve gameplay and services</li>
              <li>Provide player support</li>
              <li>Detect cheating, exploits, and abuse</li>
              <li>Protect accounts and servers</li>
              <li>Communicate important updates</li>
              <li>Moderate the community</li>
              <li>Analyze performance and stability</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">3. Sharing Information</h2>

          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              We do not sell your personal information.
            </p>

            <p>
              We may share limited information only when necessary with hosting
              providers, payment processors, anti-cheat systems, security
              services, or legal authorities if required by law.
            </p>

            <p>
              Third-party services may have their own privacy policies and
              terms.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">4. Cookies & Tracking</h2>

          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              Our website may use cookies or similar technologies to improve
              user experience and website performance.
            </p>

            <p>
              Cookies may be used to keep users logged in, remember preferences,
              and analyze traffic or usage.
            </p>

            <p>
              You can disable cookies through your browser settings, though some
              features may not function properly.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">5. Data Security</h2>

          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              We take reasonable steps to protect user information from
              unauthorized access, misuse, or loss.
            </p>

            <p>
              Passwords are stored securely and are never stored in plain text.
            </p>

            <p>
              However, no online platform or system can be guaranteed to be 100%
              secure.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">6. Data Retention</h2>

          <p className="mt-4 text-white/70 leading-7">
            We retain information only for as long as necessary to operate the
            platform, maintain security, enforce rules, resolve disputes, and
            comply with legal obligations.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">7. Children’s Privacy</h2>

          <p className="mt-4 text-white/70 leading-7">
            Delta Reloaded is not intended for children under the minimum age
            required by local law. If we become aware that personal information
            has been collected without proper consent, we may remove that
            information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">8. Community Content</h2>

          <p className="mt-4 text-white/70 leading-7">
            Anything you publicly post in Delta Reloaded communities, forums,
            chats, or social platforms may be visible to other users. Please
            avoid sharing sensitive personal information publicly.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">9. Third-Party Services</h2>

          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              Delta Reloaded may contain links or integrations with third-party
              services including Discord, payment providers, streaming
              platforms, and social media services.
            </p>

            <p>
              We are not responsible for the privacy practices or content of
              third-party services.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">10. Your Rights</h2>

          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              Depending on your location and applicable laws, you may have
              rights to:
            </p>

            <ul className="list-disc pl-6 space-y-2">
              <li>Request access to your information</li>
              <li>Request corrections to your data</li>
              <li>Request deletion of certain information</li>
              <li>Object to certain data processing activities</li>
            </ul>

            <p>
              Some requests may be limited where information is required for
              legal, security, or anti-cheat purposes.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">11. Changes to This Policy</h2>

          <p className="mt-4 text-white/70 leading-7">
            We may update this Privacy Policy from time to time. When changes
            are made, the "Last Updated" date above will also be updated.
            Continued use of Delta Reloaded after updates means you accept the
            revised policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">12. Contact</h2>

          <p className="mt-4 text-white/70 leading-7">
            If you have questions about this Privacy Policy or your data,
            please contact us through the official website:
          </p>

          <a
            href="https://deltareloaded.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block text-cyan-400 hover:text-cyan-300 transition"
          >
            https://deltareloaded.com/
          </a>
        </section>

      </div>
    </div>
  )
}
